module.exports = __webpack_public_path__ + "static/story_img2@2x-5345b29a56ed6d05de566b30efeebd62.jpg";